module.exports = __webpack_public_path__ + "img/ez-slot-ic_withdraw_mobile.69f3e9a4.png";